/**
 * Wallet service สำหรับ user-modern — ใช้ API เดียวกับ user-classic
 * GET /api/v1/wallet/tenant/:tenantId/users/:userId/wallet
 */
import { handleSessionReplaced } from '../utils/sessionReplacedHandler'
import { getRuntimeTenantIdSync } from '../lib/runtimeTenant'
import { withApiBaseUrl } from '../lib/apiBaseUrl'

function getAccessToken(): string | null {
  return localStorage.getItem('accessToken')
}

function getCurrentUser(): { id?: string; _id?: string; tenantId?: string } | null {
  try {
    const s = localStorage.getItem('user')
    return s ? JSON.parse(s) : null
  } catch {
    return null
  }
}

export interface WalletBalance {
  main: number
  bonus: number
  pending: number
  frozen: number
}

export interface WalletData {
  userId: string
  tenantId: string
  balance: WalletBalance
  currency: string
  status: string
}

export interface WalletResponse {
  success: boolean
  data?: WalletData
  error?: string
}

export async function getWallet(): Promise<WalletResponse> {
  const user = getCurrentUser()
  const token = getAccessToken()
  const tenantId = user?.tenantId || getRuntimeTenantIdSync()
  const userId = user?.id || (user as any)?._id
  if (!userId || !tenantId || !token) {
    return { success: false, error: 'ไม่พบข้อมูลผู้ใช้' }
  }
  try {
    const res = await fetch(
      withApiBaseUrl(`/api/v1/wallet/tenant/${tenantId}/users/${userId}/wallet`),
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          'X-Tenant-ID': tenantId,
        },
        credentials: 'include',
      }
    )
    const data = (await res.json()) as WalletResponse & { code?: string }
    if (res.status === 401 && data?.code === 'SESSION_REPLACED') {
      await handleSessionReplaced()
      return { success: false, error: 'SESSION_REPLACED' }
    }
    if (!res.ok) return { success: false, error: data.error || 'ดึงข้อมูล wallet ไม่สำเร็จ' }
    return data
  } catch (e) {
    return { success: false, error: (e instanceof Error ? e.message : 'เกิดข้อผิดพลาด') }
  }
}

/** ยอดเครดิตที่ใช้แสดง = หลัก + โบนัส (ตรงกับ user-classic) */
export function getDisplayBalance(wallet: WalletData | null | undefined): number {
  if (!wallet?.balance) return 0
  const b = wallet.balance
  return (b.main ?? 0) + (b.bonus ?? 0)
}

export function formatCurrency(amount: number): string {
  return new Intl.NumberFormat('th-TH', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount)
}
